import { render, staticRenderFns } from "./ModalCertificateTemplate.vue?vue&type=template&id=fc173b68&scoped=true"
import script from "./ModalCertificateTemplate.vue?vue&type=script&lang=js"
export * from "./ModalCertificateTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalCertificateTemplate.vue?vue&type=style&index=0&id=fc173b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc173b68",
  null
  
)

export default component.exports